import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { frenchTranslation, englishTranslation } from "../languages/language";

i18next.use(initReactI18next).init({
  // compatibilityJSON: "v3",
  lng: "english",
  fallbackLng: "english",
  resources: {
    english: { translation: englishTranslation },
    french: { translation: frenchTranslation },
  },
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
